var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "text-center mb-6" }, [
        _vm._v(_vm._s(_vm.$t("roomWizard.selectCredentials")))
      ]),
      _c(
        "v-form",
        {
          ref: "newLicenseForm",
          attrs: { onSubmit: "return false;", autocomplete: "off" },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex mb-4" },
            [
              _c("input", {
                staticStyle: { display: "none" },
                attrs: { autocomplete: "false", name: "hidden", type: "text" }
              }),
              _c("va-text-field", {
                staticClass: "mr-4",
                attrs: {
                  rules: [
                    _vm.required,
                    _vm.specialNotStartEndLine,
                    _vm.maxLength(_vm.userName, 20)
                  ],
                  label: _vm.$t("common.username"),
                  noAutocomplete: true
                },
                model: {
                  value: _vm.userName,
                  callback: function($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName"
                }
              }),
              _c("va-text-field", {
                attrs: {
                  password: "",
                  noAutocomplete: true,
                  label: _vm.$t("roomWizard.password")
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-space-between my-8" },
            [
              !_vm.first
                ? _c("va-button", {
                    staticClass: "mr-4",
                    attrs: {
                      color: "secondary",
                      type: "outline",
                      cta: _vm.$t("roomWizard.prev")
                    },
                    on: { click: _vm.onBack }
                  })
                : _c("v-spacer"),
              _c("va-button", {
                attrs: {
                  disabled: !_vm.valid,
                  loading: _vm.loading,
                  cta: _vm.$t("roomWizard.next")
                },
                on: { click: _vm.onFinish }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }